import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  RENTER_LEASE_SITUATION_OPTION_TO_LABEL_MAPPING,
} from 'common/leaseSituationOptionItems';

import {
  PROPERTY_TYPE_OPTION_HOME,
} from 'common/propertyTypes';

import SrExternalLink from 'client/components/SrExternalLink';
import SrCopyText from 'client/components/SrCopyText';
import SrAgentLeadMapView from 'client/components/SrAgentLeadMapView';

import {
  bedsDisplayMultipleString,
  formatPhoneNumber,
  formatPriceRange,
  formatPetString,
  getAutoTextStatus,
} from 'common/formatters';

class SrAgentLeadInformationList extends Component {
  static propTypes = {
    lead: PropTypes.object.isRequired,
  }

  render() {
    const { lead } = this.props;
    const {
      renter,
      renterActivity,
      frontAutoText,
      displayContext,
      frontConversation,
    } = lead;
    const autoTextStatus = getAutoTextStatus({ renterActivity, frontAutoText });

    return (
      <div className='sectionsContainer'>
        <div className='section'>
          <span className='title'>general</span>
          <div className='rowsContainer'>
            {!!frontConversation && (
              <div className='row'>
                <span className='left'>Text Conversation</span>
                <span className='right cursor-pointer'>
                  <SrExternalLink
                    className='linkOut front'
                    link={`https://app.frontapp.com/open/${frontConversation.conversationId}`}
                  >
                    Front
                  </SrExternalLink>
                </span>
              </div>
            )}
            <div className='row'>
              <span className='left'>Phone</span>
              <span className='right cursor-pointer'>
                <SrCopyText
                  text={renter.phone}
                  formattedText={formatPhoneNumber(renter.phone)}
                />
              </span>
            </div>
            <div className='row'>
              <span className='left'>Email</span>
              {renter.email ? (
                <span className='right cursor-pointer'>
                  <SrCopyText
                    text={renter.email}
                  />
                </span>
              ) : (
                <span className='right'>None</span>
              )}
            </div>
            {!!autoTextStatus && (
              <div className='row'>
                <span className='left'>Autotext</span>
                <span className='right'>
                  {autoTextStatus}
                </span>
              </div>
            )}
            {!!displayContext && (
              <div className='row'>
                <span className='left'>Assignment Context</span>
                <span className='right'>
                  {displayContext}
                </span>
              </div>
            )}
            <div className='row'>
              <span className='left'>Signed Up Date</span>
              <span className='right'>
                {moment(renter.createdDate).format('MMM D, YYYY')}
              </span>
            </div>
            <div className='row'>
              <span className='left'>Wants To Tour</span>
              <span className='right'>
                {renter.startTouring || 'N/A'}
              </span>
            </div>
          </div>
        </div>

        <div className='section'>
          <span className='title'>search criteria</span>
          <div className='rowsContainer'>
            <div className='row'>
              <span className='left'>Move-in Date</span>
              <span className='right'>
                {moment(renter.moveInDate).format('MMM D, YYYY')}
              </span>
            </div>
            <div className='row'>
              <span className='left'>Lease Situation</span>
              <span className='right'>
                {
                  RENTER_LEASE_SITUATION_OPTION_TO_LABEL_MAPPING[
                    renter.leaseSituation
                  ]
                }
              </span>
            </div>
            <div className='row'>
              <span className='left'>Price Range</span>
              <span className='right'>
                {formatPriceRange(renter.searchFilters)}
              </span>
            </div>
            <div className='row'>
              <span className='left'>Bedrooms</span>
              <span className='right'>
                {bedsDisplayMultipleString({ bedrooms: renter.searchFilters.bedrooms })}
              </span>
            </div>
            <div className='row'>
              <span className='left'>Pets</span>
              <span className='right'>
                {formatPetString(renter.searchFilters.pets)}
              </span>
            </div>
            <div className='row'>
              <span className='left'>Property Types</span>
              <span className='right'>
                {renter.searchFilters.propertyTypes.filter((propertyType) => {
                  return propertyType !== PROPERTY_TYPE_OPTION_HOME;
                }).join(', ')}
              </span>
            </div>
          </div>
        </div>

        <SrAgentLeadMapView lead={lead} />
      </div>
    );
  }
}

SrAgentLeadInformationList.displayName = 'SrAgentLeadInformationList';

export default SrAgentLeadInformationList;
